import { getEnvironment } from '../environment/Environment';

/**
 * Getting locale and time mode information, and normalization of locales.
 */

/**
 * Call this function to get locale string. If no locale, defaults to 'en-US'.
 *
 * @return Returns locale string.
 */
export const getLocale = (): string => {
   return getEnvironment().locale;
};

/**
 * Call this function to check if time mode is 24 hour.
 *
 * @return Returns true if time mode is 24 hour.
 */
export const isTimeMode24Hour = (): boolean => {
   return getEnvironment().timeMode24Hour;
};

/**
 * Call this function to normalize locale as lowercased language code and
 * uppercased country code separated with dash.
 *
 * @param {string} locale
 * @return Returns formatted string of locale as lowercased language code and
 * uppercased country code separated with dash.
 *
 * ```typescript
 * const localeNotFormatted: string = 'EN_us';
 * const formattedLocale: string = normalizeLocale(localeNotFormatted); // 'en-US'
 * ```
 */
export const normalizeLocale = (locale: string): string => {
   locale = locale.replace(/_/g, '-');

   if (locale.indexOf('-') < 0) {
      locale = locale + '-US';
   }

   const localeParts = locale.split('-');
   return `${localeParts[0].toLowerCase()}-${localeParts[1].toUpperCase()}`;
};
